import React from "react";
import { Section, Field, TextIn } from "./obUi";

export const ThankYouSection = ({ a, set, ro }) => {
  const firm = a.firm_name || "your firm";
  const p = { a, set, ro };
  return (
    <Section n={5} title="Your thank-you page" testId="ob-section-thankyou"
             hint="People see this right after they send their details. Leave it empty to use our standard wording with your firm name.">
      <Field label="Headline" wide>
        <TextIn {...p} k="thankyou_headline" testId="ob-ty-headline" placeholder={`Thank you — ${firm} has your case`} />
      </Field>
      <Field label="Message" wide>
        <TextIn {...p} area k="thankyou_message" testId="ob-ty-message"
                placeholder={`Your free case review request is in. Someone from ${firm} will look over what happened and get in touch soon.`} />
      </Field>
      <Field label="Welcome video link (optional)" wide hint="A YouTube or Vimeo link starting with https://">
        <TextIn {...p} k="thankyou_video_url" testId="ob-ty-video" placeholder="https://www.youtube.com/watch?v=…" />
      </Field>
    </Section>
  );
};
